import Box from 'ext-ui/components/Box/Box'
import ArrowLeft from 'ext-ui/svg/icon/ArrowLeft'
import CloudKeySvg from 'ext-ui/svg/illustration/CloudKeySvg'
import React, { useState } from 'react'
import BackgroundPage from 'src/components/BackgroundPage/BackgroundPage'
import { useTranslate } from 'src/localization/Trns'
import { usePostEnterpriseRequest } from 'src/queries/organizations/saas.queries'
import { useQueryOwnUser } from 'src/queries/users.queries'

import style from './OrganizationSSOConfig.style'

export default function OrganizationSSOUpgradeScreen() {
  const translate = useTranslate()
  const [didSendEnterpriseRequest, setDidSendEnterpriseRequest] =
    useState<boolean>(false)

  const { mutateAsync: sendPostEnterpriseRequest } = usePostEnterpriseRequest()
  const { data: currentUser } = useQueryOwnUser({})

  return (
    <BackgroundPage>
      <div
        className="OrganizationSSOConfig flex-column justify-center align-center w-full h-full gap-15"
        css={style}
      >
        <CloudKeySvg aria-label={translate('Cloud with Key Illustration')} />
        <div className="flex-column gap-3 justify-center">
          <p className="sso-upgrade-header font-bold">{translate('SSO')}</p>
          <p className="sso-upgrade-text font-support-medium">
            {translate(
              'Enable SSO to let your team login with your existing identity provider. Streamline access, strengthen security, and meet internal compliance requirements.',
            )}
          </p>
        </div>
        <Box className="sso-upgrade-box">
          <div className="flex-row gap-4 justify-between align-center">
            <div className="flex-column">
              <p className="font-bold sso-upgrade-box-headline">
                {translate('Upgrade to Extend Enterprise')}
              </p>
              <p className="font-regular">
                {translate(
                  'Enable SSO for secure, streamlined access with your existing identity provider.',
                )}
              </p>
            </div>
            <div className="arrow-left-container">
              <ArrowLeft
                className="arrow-left"
                role="button"
                aria-label={translate('Request Enterprise Access Button')}
                height={24}
                width={24}
                onClick={async () => {
                  // Prevent users from spamming this just in case
                  if (didSendEnterpriseRequest === false) {
                    await sendPostEnterpriseRequest({
                      orgId: currentUser?.organizationId!,
                      body: {
                        intention: 'SSO Config Page - Web',
                      },
                    })
                    setDidSendEnterpriseRequest(true)
                  }
                }}
              />
            </div>
          </div>
        </Box>
      </div>
    </BackgroundPage>
  )
}
